import React, { useState, useCallback } from 'react';
import { Routes, Route } from 'react-router-dom';
import InitialScreen from './screens/InitialScreen/InitialScreen.js';
import EventEndScreen from './screens/EventEndScreen/EventEndScreen.js';
import EventDetailsScreen from './screens/EventDetailsScreen/EventDetailsScreen.js';
import QuizScreen from './screens/Quiz/QuizScreen.js';
import { SessionProvider } from './context/SessionContext.js';
import RecaptchaV2Modal from './screens/_Components/RecaptchaV2Modal.js';
// import RecaptchaDebugger from './screens/_Components/RecaptchaDebugger.js';
import { getRecaptchaV2SiteKey } from './utils/recaptcha.js';
import LoadingScreen from './screens/LoadingScreen/LoadingScreen.js';

function App() {
  const [recaptchaV2Modal, setRecaptchaV2Modal] = useState({
    isOpen: false,
    onVerified: null,
    onError: null
  });

  const showRecaptchaV2Modal = useCallback((onVerified, onError) => {
    setRecaptchaV2Modal({
      isOpen: true,
      onVerified: (token) => {
        setRecaptchaV2Modal({ isOpen: false, onVerified: null, onError: null });
        if (onVerified) onVerified(token);
      },
      onError: (error) => {
        setRecaptchaV2Modal({ isOpen: false, onVerified: null, onError: null });
        if (onError) onError(error);
      }
    });
  }, []);

  const closeRecaptchaV2Modal = useCallback(() => {
    const { onError } = recaptchaV2Modal;
    setRecaptchaV2Modal({ isOpen: false, onVerified: null, onError: null });
    if (onError) onError('User cancelled reCAPTCHA verification');
  }, [recaptchaV2Modal]);

  // Make the modal handler available globally
  React.useEffect(() => {
    window.__showRecaptchaV2Modal = showRecaptchaV2Modal;
    return () => {
      delete window.__showRecaptchaV2Modal;
    };
  }, [showRecaptchaV2Modal]);

  return (
    <SessionProvider>
      <div id='MainApp'>
        <Routes>
          <Route index path='/' element={<InitialScreen />} />
          <Route path='/start' element={<EventDetailsScreen />} />
          <Route path='/quiz' element={<QuizScreen />} />
          <Route path='/end' element={<EventEndScreen />} />
          <Route path='/loading' element={<LoadingScreen />} />
        </Routes>

        {/* Global reCAPTCHA v2 Modal */}
        <RecaptchaV2Modal
          isOpen={recaptchaV2Modal.isOpen}
          onClose={closeRecaptchaV2Modal}
          onVerified={recaptchaV2Modal.onVerified}
          onError={recaptchaV2Modal.onError}
          siteKey={getRecaptchaV2SiteKey()}
        />

        {/* Debug component - only show in development */}
        {/* {process.env.NODE_ENV === 'development' && <RecaptchaDebugger />} */}
      </div>
    </SessionProvider>
  );
}

export default App;
